export function solveNumberOfPeriods(PV: number, PMT: number, i: number): number {
  if (i <= 0) return PV / PMT; // sem juros, prazo = PV/PMT
  const ratio = 1 - (PV * i) / PMT;
  if (ratio <= 0) return NaN; // pagamento insuficiente
  return -Math.log(ratio) / Math.log(1 + i);
}